import { render, staticRenderFns } from "./ShoppingCartBottomStepper-gt3.vue?vue&type=template&id=63f52b40&scoped=true"
import script from "./ShoppingCartBottomStepper-gt3.vue?vue&type=script&lang=js"
export * from "./ShoppingCartBottomStepper-gt3.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartBottomStepper-gt3.vue?vue&type=style&index=0&id=63f52b40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f52b40",
  null
  
)

export default component.exports